module.exports = __webpack_public_path__ + "img/btnvote.1d23a522.png";